import { gql } from '@apollo/client'
import {
    ManufacturerProductCatalogDetailFragment,
    ManufacturerProductDetailFragments,
    ManufacturerProductSpecDocDetailFragment,
} from '../fragments/productDetail.fragments'

export const CopyProductListing = gql`
    mutation copyProductListing($input: CopyProductListingInput!) {
        copyProductListing(input: $input) {
            listingId
        }
    }
`

export const MoveProductListing = gql`
    mutation moveProductListing($input: MoveProductListingInput!) {
        moveProductListing(input: $input) {
            listingId
        }
    }
`

export const DeleteProductListing = gql`
    mutation deleteProductListing($input: DeleteCopyMoveProductListingInput!) {
        deleteProductListing(input: $input) {
            listingId
        }
    }
`

export const SaveProductListingDetail = gql`
    mutation saveProductListingDetail(
        $saveProductListingDetailInput: ListingDetailInput!
    ) {
        saveProductListingDetail(input: $saveProductListingDetailInput) {
            listingDetail {
                assignedBPMUsers {
                    ...saveUsersFragment
                }
                assignedContactUsers {
                    ...saveUsersFragment
                }
                assignedDeltekUsers {
                    ...saveUsersFragment
                }
                buildingTypes
                catalogs {
                    ...manufacturerProductCatalogDetailFragment
                }
                categories
                documents {
                    ...manufacturerProductSpecDocDetailFragment
                }
                firmId
                firstPublished
                images {
                    ...imagesFragment
                }
                isActive
                lastPublished
                lastUpdated
                listingId
                longDescription
                model
                partnershipLinks {
                    ...partnershipLinksFragment
                }
                productId
                productName
                productType
                properties {
                    ...propertiesFragment
                }
                sectionNumber
                sectionTitle
                submissionStatus
                type
                videos {
                    ...videosFragment
                }
                webLinks {
                    ...webLinksFragment
                }
                canAutoGenerateProductSpecification
                contentLibrary
            }
        }
    }
    ${ManufacturerProductDetailFragments.imagesFragment}
    ${ManufacturerProductCatalogDetailFragment}
    ${ManufacturerProductSpecDocDetailFragment}
    ${ManufacturerProductDetailFragments.partnershipLinksFragment}
    ${ManufacturerProductDetailFragments.propertiesFragment}
    ${ManufacturerProductDetailFragments.videosFragment}
    ${ManufacturerProductDetailFragments.webLinksFragment}
    ${ManufacturerProductDetailFragments.saveUsersFragment}
`
export const CreateProductListingDetail = gql`
    mutation createProductListingDetail(
        $saveProductListingDetailInput: ListingDetailInput!
    ) {
        createProductListingDetail(input: $saveProductListingDetailInput) {
            listingDetail {
                assignedBPMUsers {
                    ...saveUsersFragment
                }
                assignedDeltekUsers {
                    ...saveUsersFragment
                }
                assignedContactUsers {
                    ...saveUsersFragment
                }
                buildingTypes
                catalogs {
                    ...manufacturerProductCatalogDetailFragment
                }
                categories
                documents {
                    ...manufacturerProductSpecDocDetailFragment
                }
                firmId
                firstPublished
                images {
                    ...imagesFragment
                }
                isActive
                lastPublished
                lastUpdated
                listingId
                longDescription
                model
                partnershipLinks {
                    ...partnershipLinksFragment
                }
                productId
                productName
                productType
                properties {
                    ...propertiesFragment
                }
                sectionNumber
                sectionTitle
                submissionStatus
                type
                videos {
                    ...videosFragment
                }
                webLinks {
                    ...webLinksFragment
                }
            }
        }
    }
    ${ManufacturerProductDetailFragments.imagesFragment}
    ${ManufacturerProductCatalogDetailFragment}
    ${ManufacturerProductSpecDocDetailFragment}
    ${ManufacturerProductDetailFragments.partnershipLinksFragment}
    ${ManufacturerProductDetailFragments.propertiesFragment}
    ${ManufacturerProductDetailFragments.videosFragment}
    ${ManufacturerProductDetailFragments.webLinksFragment}
    ${ManufacturerProductDetailFragments.saveUsersFragment}
`

export const GenerateProductSpecification = gql`
    mutation generateProductSpecification($listingId: String) {
        generateProductSpecification(listingId: $listingId) {
            downloadURI
            errorMessage
            listingId
        }
    }
`
export const SetTableViewSettings = gql`
    mutation setTableVewSetting($input: TableViewSettingInput!) {
        setTableVewSetting(input: $input) {
            selectedColumns {
                columnName
                columnWidth
                order
                isColumnPinned
                columnOrder
            }
            isTableGroupingEnabled
            tableGroupings {
                columnName
                groupingOrder
                isPinned
                isCollapsed
            }
            isTableView
            userId
        }
    }
`

export const SetProductListingDetailPartnership = gql`
    mutation setProductListingDetailPartnership(
        $setProductListingDetailPartnershipInput: SetProductDetailPartnershipInput!
    ) {
        setProductListingDetailPartnership(
            input: $setProductListingDetailPartnershipInput
        ) {
            assignedBPMUsers {
                ...saveUsersFragment
            }
            assignedContactUsers {
                ...saveUsersFragment
            }
            assignedDeltekUsers {
                ...saveUsersFragment
            }
            buildingTypes
            catalogs {
                ...manufacturerProductCatalogDetailFragment
            }
            categories
            documents {
                ...manufacturerProductSpecDocDetailFragment
            }
            firmId
            firstPublished
            images {
                ...imagesFragment
            }
            isActive
            lastPublished
            lastUpdated
            listingId
            longDescription
            model
            partnershipLinks {
                ...partnershipLinksFragment
            }
            productId
            productName
            productType

            properties {
                ...propertiesFragment
            }
            sectionNumber
            sectionTitle
            submissionStatus
            type
            videos {
                ...videosFragment
            }
            webLinks {
                ...webLinksFragment
            }
            canAutoGenerateProductSpecification
        }
    }
    ${ManufacturerProductDetailFragments.imagesFragment}
    ${ManufacturerProductCatalogDetailFragment}
    ${ManufacturerProductSpecDocDetailFragment}
    ${ManufacturerProductDetailFragments.partnershipLinksFragment}
    ${ManufacturerProductDetailFragments.propertiesFragment}
    ${ManufacturerProductDetailFragments.videosFragment}
    ${ManufacturerProductDetailFragments.webLinksFragment}
    ${ManufacturerProductDetailFragments.saveUsersFragment}
`
